import request from '@/utils/request'

let RankingApi = {

 
    List(data) {
        return request._post('/shop/plus.ranking.index/list', data);
    },
    
    Add(data) {
        return request._post('/shop/plus.ranking.index/add', data);
    },
    
    Edit(data) {
        return request._post('/shop/plus.ranking.index/edit', data);
    },
   
    Del(data) {
        return request._post('/shop/plus.ranking.index/del', data);
    },
    sourceList(data) {
        return request._post('/shop/plus.ranking.source/list', data);
    },
    
    sourceAdd(data) {
        return request._post('/shop/plus.ranking.source/add', data);
    },
    
    sourceEdit(data) {
        return request._post('/shop/plus.ranking.source/edit', data);
    },
   
    sourceDel(data) {
        return request._post('/shop/plus.ranking.source/del', data);
    },

 
    /*获取设置*/
    getSetting(data) {
        return request._get('/shop/plus.ranking.setting/index', data);
    },
    /*保存设置*/
    saveSetting(data) {
        return request._post('/shop/plus.ranking.setting/index', data);
    },
}

export default RankingApi;



// WEBPACK FOOTER //
// ./src/api/ranking.js